export default "__VITE_ASSET__9a288107__"